import styled from "styled-components";

export const Container = styled.div`
position: relative;
min-height: calc(100vh - 60px);
padding-top: 32px;
padding-bottom: 104px;

.text-01 {
    color: #000;
    font-weight: 600;
    margin-bottom: 23px;
}

.text-02 {
    color: #000;
    margin-bottom: 37px;
}

.text-03 {
    color: #000;
    margin-bottom: 14px;
}

.ui {
    &.form {
        position: unset;

        .line {
            margin: 40px 0px 32px;
        }

        .pdfs-btns {
            display: flex;
            margin-top: 34px;
        }

        .footer {
            width: 100%;
            position: absolute;
            bottom: 28px;
        }
    }
}

.use-term-modal,
.privacy-policy-modal {
    .modal-dialog {
        max-width: 100%;
        margin: 20px;

        .modal-content {
            padding: 16px;

            .modal-header {
                display: block;
                text-align: right;
                margin-right: 5px;
                margin-bottom: 10px;

                .icon,
                .modal-title {
                    display: none;
                }

                .btn-modal-close {
                    border: 2px solid currentColor;
                    border-radius: 100px;
                    color: #1C1B1F;
                    transition: transform 300ms ease-in-out, background 150ms ease-in-out;

                    &:hover {
                        transform: rotate(90deg);
                        background: rgba(0, 0, 0, 0.06);
                    }
                }
            }

            .modal-body {
                .modal-description {
                    margin-bottom: 0px;
                }
            }

            .modal-footer {
                padding: 10px 0px;

                .btn-first {
                    background: #F4C600;
                    box-shadow: 0 8px 18px rgba(81, 98, 116, 0.12);
                    border-radius: 50px;
                    height: 40px;
                    padding: 1px 24px;
                    font-weight: 600;
                }
            }
        }
    }
}
`